/**
 * 无菜单  单独页 分发
 * @author FJJ
 * @version 1.0
 * @Time 2022.07.02
 *
 * */
import React from 'react'
import {Switch,Route,} from 'react-router-dom'

import DownLoading from "@pages/ShipperManagement/EstimatedShippingOrder/DownLoading"; // 预计出货订单 图片下载中显示页

class ShipperRouter extends React.Component{
    render() {
        return (
            <Switch>
                <Route path="/act/shipperManagement/downloading" component={DownLoading} />
            </Switch>
        );
    }
};

export default ShipperRouter;